<template>
  <div>
    <div v-if="displayConfirmationModal" class="overlay-close" @click="closeModal" />
    <div v-if="displayConfirmationModal" class="modal modal__small">
      <ConfirmationModal modal-class-name="modal-wrapper l-flex-column">
        <template slot="content">
          <div>Do you really want to disable the datamining ?</div>
        </template>
        <template slot="footer">
          <div class="footer-content l-flex-row--between">
            <div class="btn btn--medium" @click="closeModal">
              No
            </div>
            <div class="btn btn--medium btn-rev" @click="disableDataMining">
              Yes
            </div>
          </div>
        </template>
      </ConfirmationModal>
    </div>
    <div class="l-2-col">
      <div class="l-col-left">
        <div class="settings-section">
          <switchItem
            class="header h1"
            label="datamining"
            type="dataMining"
            input-name="datamining"
            :is-switch-active="uiDataminingSettings.datamining"
          />
          <template v-if="uiDataminingSettings.datamining">
            <switchItem
              class="section-item"
              label="Encryption"
              type="dataMining"
              input-name="encryption"
              :is-switch-active="uiDataminingSettings.encryption"
              :is-disabled="!uiDataminingSettings.datamining"
              @change="saveDataminingSettings('encryption', 'Encryption')"
            />
            <switchItem
              class="section-item"
              label="Full mode"
              type="dataMining"
              input-name="fullmode"
              :is-switch-active="uiDataminingSettings.fullmode"
              :is-disabled="!uiDataminingSettings.datamining"
              @change="saveDataminingSettings('fullmode', 'Full mode')"
            />
            <switchItem
              class="section-item"
              label="Second party"
              type="dataMining"
              input-name="secondparty"
              :is-switch-active="uiDataminingSettings.secondparty"
              :is-disabled="!uiDataminingSettings.datamining"
              @change="saveDataminingSettings('secondparty', 'Second party')"
            />
            <switchItem
              class="section-item"
              label="Third party"
              type="dataMining"
              input-name="thirdparty"
              :is-switch-active="uiDataminingSettings.thirdparty"
              :is-disabled="!uiDataminingSettings.datamining"
              @change="saveDataminingSettings('thirdparty', 'Third party')"
            />
            <switchItem
              class="section-item"
              label="Alt-IDs"
              type="dataMining"
              input-name="altid"
              :is-switch-active="uiDataminingSettings.altid"
              :is-disabled="!uiDataminingSettings.datamining"
              @change="saveDataminingSettings('altid', 'Alt-IDs')"
            />
          </template>
        </div>
      </div>
      <div v-if="uiDataminingSettings.datamining" class="l-col-right">
        <div class="settings-section mg-tp-53">
          <div class="form-label__required">
            SSH public key
          </div>
          <textarea
            class="form-input form-textarea"
            placeholder="Please provide your SSH public key"
            v-model="sshKey"
            id="sshkey"
            name="sshkey"
            type="text"
            @input="sshkeyInputHandler($event)"
          />
          <div class="ssh-error" v-show="isSshKeyValid === false">
            <span class="form-validate-error">A valid SSH public key is mandatory</span>
          </div>
          <div class="l-flex-row--rev">
            <div class="btn btn--medium btn--round" @click="resetDatamining">
              Cancel
            </div>
            <div class="btn btn--medium btn--round btn-rev" :class="{'ui-disabled': isSaveDataMiningDisabled }" @click="activateDatamining">
              Save
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ConfirmationModal from '@/components/common/confirmationModal'
import SwitchItem from '@/components/common/SwitchItem'
import { mapState, mapActions, mapMutations } from 'vuex'

export default {
    components: {
        ConfirmationModal,
        SwitchItem,
    },
    data() {
        return {
            datamining: 'active',
            sshKey: '',
            isSshKeyChanged: false,
            isSshKeyValid: null,
            processing: false
        }
    },

    mounted() {
        this.selectSetting()
    },

    computed: {
        ...mapState('data/settings', {
            dataminingSettings: state => state.dataMining,
        }),

        ...mapState('ui/settings', {
            uiSettingName: state => state.settingName,
            uiDataminingSettings: state => state.dataMining,
            displayConfirmationModal: state => state.displayModal,

        }),

        isSaveDataMiningDisabled() {
            return !(this.uiDataminingSettings.datamining && this.isSshKeyValid && this.isSshKeyChanged)
        },
    },

    methods: {
        ...mapActions('data/settings', ['checkDataMiningKey','updateSettings' ]),

        ...mapMutations('ui/settings', [
            'resetUiDataminingSettings',
            'setDataMiningSetting',
            'setDisplayModal',
        ]),

        selectSetting() {
            this.sshKey = this.dataminingSettings.sshKey
            this.isSshKeyValid = null
        },

        //- DATAMINING
        closeModal() {
            this.setDataMiningSetting({ type: 'datamining', activate: !this.uiDataminingSettings.datamining })
            this.setDisplayModal({ display: false })
        },

        async saveDataminingSettings(key, label) {
            const props = {
                encryption: 'datamining_encryption',
                fullmode: 'datamining_fullmode',
                secondparty: 'datamining_2ndparty_activated',
                thirdparty: 'datamining_3rdparty_activated',
                altid: 'datamining_altids_activated',
            }
            const params = {
                datamining_activation: 'sftp',
            }
            params[props[key]] = this.setsApiData(this.uiDataminingSettings[key])

            const notifAction = this.uiDataminingSettings[key] ? 'enabled' : 'disabled'
            await this.updateSettings({
                params,
                type: 'datamining',
                notificationLabel: `${label} is ${notifAction}`
            })
            this.resetDatamining()
        },

        async activateDatamining() {
            if (this.isSshKeyValid) {
                const params = {
                    datamining_activation: 'sftp',
                    datamining_encryption: this.setsApiData(this.uiDataminingSettings.encryption),
                    datamining_fullmode: this.setsApiData(this.uiDataminingSettings.fullmode),
                    datamining_2ndparty_activated: this.setsApiData(this.uiDataminingSettings.secondparty),
                    datamining_3rdparty_activated: this.setsApiData(this.uiDataminingSettings.thirdparty),
                    datamining_altids_activated: this.setsApiData(this.uiDataminingSettings.altid),
                    ssh_public_key: this.sshKey
                }
                await this.updateSettings({
                    params,
                    type: 'datamining',
                    notificationLabel: 'Datamining is enabled'
                })
                this.resetDatamining()
                this.isSshKeyChanged = false
            }
        },

        disableDataMining() {
            this.sshKey = ''
            this.isSshKeyValid = null
            const params = {
                datamining_activation: 'none',
                ssh_public_key: this.sshKey
            }
            this.updateSettings({
                params,
                type: 'datamining',
                notificationLabel: 'Datamining is disabled'
            })
        },

        resetDatamining() {
            if (this.processing) return
            this.sshKey = this.dataminingSettings.sshKey
            this.isSshKeyValid = null
            this.resetUiDataminingSettings({ settings: this.dataminingSettings })
        },
        setsApiData(data) {
            return data ? 'YES' : 'NO'
        },

        sshkeyInputHandler(event) {
            const { value } = event.target
            this.isSshKeyChanged = value !== this.dataminingSettings.sshKey
            if (value || value !== '') {
                if (value.match(/^---- BEGIN SSH2 PUBLIC KEY ----\n/) && value.match(/\n---- END SSH2 PUBLIC KEY ----$/)) {
                    this.checkDataMiningKey({ key: value.replace(/\n+$/) })
                        .then(isValid => {
                            this.isSshKeyValid = isValid || false
                        })
                        .catch(() => {
                            this.isSshKeyValid = false
                        })
                } else {
                    this.isSshKeyValid = false
                }
            } else {
                this.isSshKeyValid = false
            }
        }
    }
}
</script>
